import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const MenuButton = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <div className="menu">
      <button onClick={toggleMenu}>Toggle Menu</button>
      {isMenuOpen && (
        <ul className="menu-items">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/page1">Page 1</Link>
          </li>
          <li>
            <Link to="/page2">Page 2</Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default MenuButton;
